export default function Resume() {
  const experiences = [
    {
      period: '10/23 - Present',
      company: 'ALKAMI TECHNOLOGY',
      logo: 'https://public.readdy.ai/ai/img_res/e11c14af0b86a8c1ca0166c0444d25d4.jpg',
      role: 'UX Designer',
      description: 'Leading design initiatives for digital banking solutions, focusing on user-centered design and accessibility standards.'
    },
    {
      period: '4/23 - 10/23',
      company: 'SPECTRUM',
      logo: 'https://readdy.ai/api/search-image?query=Modern%20telecommunications%20company%20logo%20design%20with%20blue%20and%20navy%20colors%2C%20clean%20minimalist%20style%2C%20abstract%20wave%20or%20signal%20icon%2C%20professional%20corporate%20branding%2C%20simple%20and%20memorable%2C%20white%20background%2C%20vector%20style%20illustration&width=200&height=80&seq=spectrum-logo-001&orientation=landscape',
      role: 'Designer I',
      description: 'Designed user interfaces for telecommunications products, collaborated with cross-functional teams to deliver seamless experiences.'
    },
    {
      period: '4/22 - 4/23',
      company: 'APPLE INC',
      logo: 'https://readdy.ai/api/search-image?query=Apple%20company%20logo%20iconic%20bitten%20apple%20symbol%20in%20black%2C%20minimalist%20design%2C%20clean%20professional%20style%2C%20simple%20silhouette%2C%20white%20background%2C%20vector%20style%20illustration%2C%20recognizable%20tech%20brand&width=200&height=80&seq=apple-logo-001&orientation=landscape',
      role: 'Product Designer',
      description: 'Contributed to product design projects, focusing on intuitive interfaces and maintaining Apple\'s design excellence standards.'
    }
  ];

  return (
    <section id="resume" className="py-16 md:py-24 px-6 md:px-8 bg-white">
      <div className="max-w-7xl mx-auto rounded-3xl p-8 md:p-12 shadow-lg" style={{ backgroundColor: '#f2f6f8' }}>
        <div className="mb-12 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-bold mb-4 text-gray-900">
            Resume
          </h2>
          <p className="text-base md:text-lg text-gray-600">
            Need the receipts? Here's my career highlight-reel in one polished PDF.
          </p>
        </div>

        <div className="bg-[#F8F8F8] rounded-3xl p-8 md:p-12 mb-12">
          <div className="flex flex-col items-center text-center mb-8">
            <div className="w-16 h-16 md:w-20 md:h-20 bg-[#FF6B4A] rounded-2xl flex items-center justify-center mb-6">
              <i className="ri-file-pdf-line text-3xl md:text-4xl text-white"></i>
            </div>
            <h3 className="text-xl md:text-2xl font-medium text-gray-900 mb-2">
              Want the full timeline?
            </h3>
            <p className="text-gray-600 mb-6">
              Click here to view or download my resume.
            </p>
            <a
              href="https://drive.google.com/file/d/14h6yiHa3-9a0ZqBQAfpD1DzB_iXXEKtM/view?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-3 bg-white text-gray-900 text-sm font-medium tracking-wide rounded-full border-2 border-gray-900 hover:bg-gray-900 hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              View
            </a>
          </div>
        </div>

        <div className="space-y-8 md:space-y-12">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 md:gap-8 mb-12">
          </div>
        </div>

        <div className="mt-12 text-center">
          <a
            href="https://www.linkedin.com/in/okennaokpareke/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-[#FF6B4A] hover:text-[#FF5A3A] transition-colors duration-300 cursor-pointer"
          >
            <span className="text-sm font-medium">View Full Experience on LinkedIn</span>
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}